import { guidFor } from '@ember/object/internals';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { modifier } from 'ember-modifier';
import HotelChannelPricingTablesCellsChannelsTablePricesChannelsTablePricingRowCellContent from 'lumen/components/hotel/channel-pricing/tables/cells/channels-table/prices/channels-table-pricing-row-cell-content';
import HotelChannelPricingTablesCellsChannelsTableRestrictionsChannelsTableRestrictionsRowCellContent from 'lumen/components/hotel/channel-pricing/tables/cells/channels-table/restrictions/channels-table-restrictions-row-cell-content';
import type {
  TdChannelsTableColumnSignature,
  TdChannelsTableRowSignature,
} from 'lumen/components/hotel/channel-pricing/tables/channels-table';
import { CHANNELS_TABLE_ROW_TYPES } from 'lumen/utils/constants/channel-pricing-constants';

import styles from './td-channels-table-value-cell.module.css';

interface HotelChannelPricingTablesCellsChannelsTableTdChannelsTableValueCellSignature {
  Args: {
    column: TdChannelsTableColumnSignature;
    row: TdChannelsTableRowSignature;
  };
}

export default class HotelChannelPricingTablesCellsChannelsTableTdChannelsTableValueCell extends Component<HotelChannelPricingTablesCellsChannelsTableTdChannelsTableValueCellSignature> {
  @service('channel-pricing/table-hover')
  declare channelPricingTableHover: Services['channel-pricing/table-hover'];

  cellId = `channels-table-value-cell-${guidFor(this)}`;

  handleHoverEventHandlers = modifier((cellWrappingElement) => {
    const mouseEnterHandler = (): void => {
      this.channelPricingTableHover.hoveredColumnId = this.args.column.id;
    };

    const mouseLeaveHandler = (): void => {
      this.channelPricingTableHover.hoveredColumnId = null;
    };

    cellWrappingElement.addEventListener('mouseenter', mouseEnterHandler);
    cellWrappingElement.addEventListener('mouseleave', mouseLeaveHandler);

    return (): void => {
      cellWrappingElement.removeEventListener('mouseenter', mouseEnterHandler);
      cellWrappingElement.removeEventListener('mouseleave', mouseLeaveHandler);
    };
  });

  get isCellOfHoveredColumn(): boolean {
    if (
      this.channelPricingTableHover.hoveredColumnId !== null &&
      this.channelPricingTableHover.hoveredColumnId === this.args.column.id
    ) {
      return true;
    }

    return false;
  }

  get isRestrictionsRow(): boolean {
    return this.args.row.type === CHANNELS_TABLE_ROW_TYPES.RESTRICTION;
  }

  <template>
    <div
      class="relative flex h-full flex-row items-center justify-end gap-100
        {{if this.isCellOfHoveredColumn styles.highlighted}}
        {{if @column.isPastDay styles.is-past}}"
      {{this.handleHoverEventHandlers}}
      data-test-id="td-channels-table-value-cell"
    >
      {{#if this.isRestrictionsRow}}
        <HotelChannelPricingTablesCellsChannelsTableRestrictionsChannelsTableRestrictionsRowCellContent
          @column={{@column}}
          @parentCellId={{this.cellId}}
          @row={{@row}}
        />
      {{else}}
        <HotelChannelPricingTablesCellsChannelsTablePricesChannelsTablePricingRowCellContent
          @column={{@column}}
          @row={{@row}}
        />
      {{/if}}
    </div>
  </template>
}
